import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as config from "../constants/config";
import * as orderStatus from "../constants/orderStatus";
import * as formatHelper from "../helpers/formatHelper";
import * as handlers from "../constants/handlers";

export const myOrdersTabInit = (tabId) => ({
    type: actionTypes.MY_ORDERS_TAB_INIT,
    payload: {
        tabId: tabId
    }
});

export const getMyOrders = (tabId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MY_ORDERS_GET_DATA,
        params: {
            offset: 0,
            rowCount: config.MAX_ORDERS_LIMIT,
            statusFilter: orderStatus.MY_ORDER_STATUS_LIST
        }
    },
    method: handlers.MY_ORDERS_GET_DATA,
    tabId: tabId
});

export const reloadMyOrders = (
    tabId,
    filter,
    offset,
    products,
    fandecks,
    formulas,
    customers,
    dateFrom,
    dateTo,
    sortingAsc,
    sortingCriterion,
    searchFields
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MY_ORDERS_GET_DATA,
        params: {
            asc: sortingAsc,
            colors: formulas,
            customers: customers,
            dateFrom: dateFrom,
            dateTo: dateTo,
            fandecks: fandecks,
            offset: offset,
            orderBy: sortingCriterion,
            products: products,
            rowCount: config.MAX_ORDERS_LIMIT,
            search: filter,
            searchFields: formatHelper.getOrderSearchItemsForServer(searchFields),
            statusFilter: orderStatus.MY_ORDER_STATUS_LIST
        }
    },
    method: handlers.MY_ORDERS_GET_DATA_WITH_OFFSET,
    tabId: tabId
});

export const getOrderDetail = (tabId, orderId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ORDER_DETAIL,
        params: {
            id: orderId
        }
    },
    method: handlers.MY_ORDERS_GET_DETAIL,
    tabId: tabId
});

export const sendOrder = (tabId, orderCrate) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_ORDER_RECORD,
        params: {
            productId: orderCrate.productId,
            fandeckId: orderCrate.fandeckId,
            fandeckLocal: orderCrate.colorLocal,
            colorId: orderCrate.colorId,
            colorLocal: orderCrate.colorLocal,
            formulaId: orderCrate.formulaId,
            formulaLocal: orderCrate.colorLocal,
            baseId: orderCrate.baseId,
            formulaColorants: orderCrate.formulaColorants,
            scaling: orderCrate.scaling,
            customerId: orderCrate.customerId,
            packageCount: orderCrate.numberOfPackages,
            packageId: orderCrate.packageId,
            customPackage: orderCrate.customPackage,
            customPackageSize: orderCrate.customPackageSize,
            customPackageUnit: orderCrate.customPackageUnit,
            brand: orderCrate.databaseName,
            receiver: orderCrate.receiverUuid,
            moreInfo: orderCrate.customNote,
            moreInfoInternal: orderCrate.moreInfoInternal,
            orderRecordType: orderCrate.orderRecordType
        }
    },
    method: handlers.ADD_ORDER_RECORD_AND_CLOSE_MODAL,
    tabId: tabId
});

export const changeFilter = (tabId, filter) => ({
    type: actionTypes.MY_ORDERS_SAVE_FILTER,
    payload: {
        tabId: tabId,
        filter: filter
    }
});

export const changeSorting = (tabId, criterion, asc) => ({
    type: actionTypes.MY_ORDERS_SAVE_SORTING,
    payload: {
        tabId: tabId,
        criterion: criterion,
        asc: asc
    }
});

export const changeOffset = (tabId, offset) => ({
    type: actionTypes.MY_ORDERS_CHANGE_OFFSET,
    payload: {
        tabId: tabId,
        offset: offset
    }
});

export const getOrderDetailAndOpenModal = (tabId, orderId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ORDER_DETAIL,
        params: {
            id: orderId
        }
    },
    method: handlers.MY_ORDERS_GET_DETAIL_AND_OPEN_MODAL,
    tabId: tabId
});
